/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {useState, useEffect, useCallback, useContext} from 'react';

import {ViewModelForm} from '@xengage/gw-portals-viewmodel-react';
import {useAuthentication} from '@xengage/gw-digital-auth-react';
import {useValidation} from '@xengage/gw-portals-validation-react';
import {UserService} from 'gw-capability-gateway';
import {WizardPage, wizardProps} from '@xengage/gw-portals-wizard-react';
import {FormattedMessage, useTranslator} from '@jutro/locale';
import {LoadSaveService} from 'gw-capability-gateway-quoteandbind';
import {MLModalService} from 'ml-portals-services-react';
import {MLDisclosureUtil, MLErrorMessageUtil} from 'ml-portals-util-js';
import {MLDisclosureComponent, MLScriptComponent} from 'ml-components-common-react';
import {MLUWIssuesPanelComponent} from 'gw-capability-gateway-quoteandbind-common-react';
import {MLPortalStorageService, MLMultiLobsDataHolderService, MLBundleService} from 'ml-services-common-react';
import {MLDriverVehicleUtil, MLNotificationBlockUtil, MLWizardNavUtil} from 'ml-portals-util-react';
import { MLRatingFactorComponent } from 'ml-capability-quoteandbind-common-react';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import '@xengage/gw-platform-translations';
import _ from 'lodash';

import {FormModalPopover, platformMessages} from 'ml-components-platform-react';
import PATrackEvent from '../../components/TrackEvent/PATrackEvent';
import messages from './GatewayDisclosurePage.messages';
import styles from './GatewayDisclosurePage.module.scss';
import paMetadata from './GatewayPADisclosurePage.metadata.json5';
import pupMetadata from './GatewayPUPDisclosurePage.metadata.json5';
import PUMBTrackEvent from '../../components/TrackEvent/PUMBTrackEvent';
import { useModal } from '@jutro/components';

const mvrExecutedStates = ['paDisclosureReviewToBuy', 'pupDisclosureReviewToBuy'];
const PA_LIC_SUSP_LICENSE_SUSPENDED_TYPE = 'license_is_suspended_revoked';
const PA_LIC_SUSP_LICENSE_SUSPENDED_CODE = '12011';
const PA_LIC_SUSP_INCIDENT_THRESHOLD_IN_YEARS = 3;
const PA_LIC_SUSP_DRIVERS_AGE_THRESHOLD = 24;
const currentYear = new Date().getFullYear();
const AUTO_DISCLOSURE_STEP = 'paDisclosureToQuote';
const CDC_EXCEPTION = 'ConcurrentDataChangeException';
// Block id for the "premium may have changed" warning so it can only ever be shown once,
// regardless of which code path (MVR dedup or premium-changed-by-MVR) triggers it.
const PREMIUM_CHANGED_ALERT_BLOCK = 'adjustedPremiumMessageContainer';

// ML: MLDisclosureCtrl.js, agent/MLDisclosureCtrl.js, ml-pa-disclosure.html, ml-pup-disclosure.html

// This controller is meant to be used only for PA and PUP (Agent)
// Shared for both DislosureToQuote and DisclosurePreviewToBuy
// HO has its own HODisclosureToQuote

function GatewayDisclosurePage(props) {
    const isGPA = appConfig.portalCode === 'GPA';
    const translator = useTranslator();

    const {authHeader} = useAuthentication();
    const {
        wizardData: submissionVM, goNext, currentStep, steps, jumpTo, updateWizardData, updateWizardSnapshot, isSkipping, wizardSnapshot
    } = props;

    const {
        ML_STORAGE_KEY_PREVIOUS_PREMIUM,
        MLUWIssuesBlockingPoints
    } = appConfig;

    const {nextStepVisited} = MLWizardNavUtil(props);
    const viewModelService = useContext(ViewModelServiceContext);
    const modalApi = useModal();
    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const {
        checkHiDrivers,
        checkPendingMvrOrderStatus,
        displayPADriverSuspendedMessage
    } = MLDriverVehicleUtil();


    const {
        addWarningAlert,
        clearBlockAlerts,
        addErrorAlert,
        clearWarningAlerts
    } = MLNotificationBlockUtil();


    const {isComponentValid} = useValidation(currentStep.id);
    const quoteID = _.get(submissionVM, 'quoteID.value')

    // init
    const [premiumChangedByMVRFlag, updatePremiumChangedByMVRFlag] = useState(undefined);
    const [insurViewWarningMsg, setInsurViewWarningMsg] = useState(false);
    const isPersonalAuto = submissionVM.value.isPersonalAuto();
    const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();

    const lobModel = isPersonalAuto ? _.get(submissionVM, 'lobData.personalAuto.coverables') : _.get(submissionVM, 'lobData.personalUmbrella.coverables');
    const mvrExecuted = mvrExecutedStates.indexOf(currentStep.mlStepName) >= 0;
    const userHasEditDisclosuresPermission = !mvrExecuted;
    const [paSuspensionMessagedDisplayed, updatePaSuspensionMessagedDisplayed] = useState(false);
    const discloseExcludedDriver = _.get(submissionVM, 'baseData.canDiscloseExcludedDrivers_ML.value') || false;
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const [accidents, setAccidents] = useState([]);
    const [claims, setClaims] = useState([]);
    const [violations, setViolations] = useState([]);
    const [losses, setLosses] = useState([]);
    const [uwIssues, setUwIssues] = useState([]);
    const [scriptML, updateScriptML] = useState([]);

    const homeLossOwners = !isPersonalAuto ? submissionVM.value.persons : undefined;
    const isBundle_ML = submissionVM.isBundle_ML.value;

    function between(str, start, end) {
        const startIndex = str.indexOf(start);
        if (startIndex === -1)
            return "";

        const endIndex = str.indexOf(end, startIndex + start.length);
        if (endIndex === -1)
            return "";

        return str.substring(startIndex + start.length, endIndex);
    }

    const showPremiumChangedAlert = useCallback(() => {
        if (isPersonalAuto || isPersonalUmbrella) {
            clearBlockAlerts(PREMIUM_CHANGED_ALERT_BLOCK);
            addWarningAlert(messages.premiumChangedDueToInfoReceivedAgent, PREMIUM_CHANGED_ALERT_BLOCK);
        }
    }, [addWarningAlert, clearBlockAlerts, isPersonalAuto, isPersonalUmbrella]);

    const displayMVRDedupedWarning = () => {
    clearBlockAlerts(PREMIUM_CHANGED_ALERT_BLOCK);
    if(submissionVM?.value.mvrDeduped_Ext)
        addWarningAlert(messages.premiumChangedDueToInfoReceivedAgent, PREMIUM_CHANGED_ALERT_BLOCK);
    }

    const setPremiumChangedByMVRFlag = () => {
        const getSelectedQuote = () => {
            if (submissionVM.bindData && submissionVM.bindData.chosenQuote
                && submissionVM.quoteData && submissionVM.quoteData.offeredQuotes) {
                const selectedQuoteId = submissionVM.bindData.chosenQuote.value;
                return submissionVM.quoteData.offeredQuotes.value.find((q) => q.publicID === selectedQuoteId);
            }
            return null;
        };

        const costsAreEqual = (costA, costB) => {
            if (costA && costB) {
                return costA.amount === costB.amount && costA.currency === costB.currency;
            }
            return true;
        };

        const isBlockingUWIssue = (uwIssue) => {
            return uwIssue.currentBlockingPoint !== MLUWIssuesBlockingPoints.NON_BLOCKING;
        };

        const getBlockingUWIssues = () => {
            return submissionVM.value.uwIssues_ML && submissionVM.value.uwIssues_ML.length
                ? submissionVM.value.uwIssues_ML.filter((uwIssue) => isBlockingUWIssue(uwIssue))
                : [];
        };

        if (mvrExecuted) {
            const storagePromise = MLPortalStorageService.retrieve(submissionVM.quoteID.value, null, ML_STORAGE_KEY_PREVIOUS_PREMIUM, authHeader);
            // ModalService.showProgressDialog('ml.quoteandbind.common.controllers.MLDisclosureCtrl.Synchronizing quote...', storagePromise);
            storagePromise.then((response) => {
                if (response && !_.isEmpty(response)) {
                    const formerCosts = JSON.parse(response);
                    const selectedQuote = getSelectedQuote();
                    const matchingFormerQuote = formerCosts.find((quote) => {
                        return quote.publicID === selectedQuote.publicID;
                    });
                    const flag = !costsAreEqual(matchingFormerQuote.monthlyPremium, selectedQuote.premium.monthlyPremium) || !costsAreEqual(matchingFormerQuote.total, selectedQuote.premium.total);

                    MLDisclosureUtil.setRequoteAfterMvr(submissionVM.quoteID.value, flag);
                    updatePremiumChangedByMVRFlag(flag);

                    if (flag) {
                        setUwIssues(getBlockingUWIssues());
                        submissionVM.value.blockNavigation_ML = uwIssues.length > 0;

                        if (currentStep.mlStepName === 'paDisclosureReviewToBuy' || currentStep.mlStepName === 'pupDisclosureReviewToBuy') {
                            showPremiumChangedAlert();
                        };
                    }
                } else {
                    updatePremiumChangedByMVRFlag(false);
                }
            }, () => updatePremiumChangedByMVRFlag(false));
        } else {
            MLDisclosureUtil.setRequoteAfterMvr(submissionVM.quoteID.value, false);
        }
    };
    useEffect(() => {
        if (isGPA && !isSkipping) {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, {step: 'Disclosure Page'});
                } else {
                    PATrackEvent('Quote Step Reached', isSkipping, submissionVM, user, {step: 'Disclosure Page'});
                }
            });

            if (isPersonalAuto) {
                LoadSaveService.getScript(AUTO_DISCLOSURE_STEP, {quoteID: submissionVM.quoteID.value}, authHeader)
                    .then((lines) => {
                        updateScriptML(lines);
                    });
            }
        }

        displayMVRDedupedWarning()
    }, []);

    useEffect(() => {
        setTimeout(() => {
            const element = document.getElementById("accidentsRow");
            if (element) {
                element.focus();
            }
        }, 100)
    }, []);

    const showFurtherRA = useCallback(() => {
        if(!isModernProduct) {
            return false
        } else {
            const hasAccidents = accidents.filter((accident) => _.isEmpty(accident.removeReason)).length > 0
            const hasClaims = claims.filter((claim) => _.isEmpty(claim.removeReason)).length > 0
            const hasViolations = violations.filter((violation) => _.isEmpty(violation.removeReason)).length > 0
            return hasAccidents || hasClaims || hasViolations
        }
    }, [isModernProduct, accidents, claims, violations])

    const handleNextIfMVRExecuted = async () => {
        if (!_.isUndefined(premiumChangedByMVRFlag)) {
            if (isBundle_ML && premiumChangedByMVRFlag) {
                if (MLBundleService.inPostQuote()) {
                    MLBundleService.markJobsForPrequote();
                }
            }

            if (nextStepVisited()) {
                goNext();
            } else {
                _.unset(submissionVM.value, 'bindData.paymentDetails');
                showProgressDialog(platformMessages.saveAndQuoteSubmission);
                try {
                    const res = await LoadSaveService.updateQuotedSubmission(
                        submissionVM.value,
                        authHeader
                    );
                    submissionVM.value = res;
                    if (premiumChangedByMVRFlag) {
                        const indexOfQuoteDetailsPage = _.findIndex(steps, ({path}) => path === '/quote');
                        jumpTo(indexOfQuoteDetailsPage);
                    } else {
                        if (!nextStepVisited()) {
                            return submissionVM;
                        }
                        updateWizardSnapshot(submissionVM);
                        goNext();
                    }
                } catch (error) {
                    MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                } finally {
                    hideProgressDialog(platformMessages.saveAndQuoteSubmission);
                }
            }
        }
        return false;
    };

    const ageLessThanThreshold = (driver) => {
        return currentYear - driver.dateOfBirth.year < PA_LIC_SUSP_DRIVERS_AGE_THRESHOLD;
    };

    const isSuspension = (violation) => {
        return currentYear - violation.date.year < PA_LIC_SUSP_INCIDENT_THRESHOLD_IN_YEARS && (violation.type === PA_LIC_SUSP_LICENSE_SUSPENDED_TYPE || violation.code === PA_LIC_SUSP_LICENSE_SUSPENDED_CODE);
    };

    const hasPASuspension = (driver) => {
        return driver.disclosures_ML.violations.some((violation) => isSuspension(violation));
    };

    const pADriverSuspended = () => {
        return submissionVM.value.baseData.policyAddress.state === 'PA' && submissionVM.value.lobData.personalAuto !== undefined && submissionVM.value.lobData.personalAuto.coverables.drivers.some((driver) => {
            return ageLessThanThreshold(driver) && hasPASuspension(driver);
        });
    };

    const callPADriverSuspended = () => {
        displayPADriverSuspendedMessage();
        updatePaSuspensionMessagedDisplayed(true);
    };

    /*
     * Check if there is any disclosure coming from a report
     */
    const foundViolationsFromReport = () => {
        const hasViolationsFromReport = (array) => {
            return array.some((v) => v.source === 'lexisNexis');
        };
        return hasViolationsFromReport(violations);
    };

    const filterDriversForAutoandUmb = (driver, type) => {
        return driver.hasOwnProperty('type_ML') && driver.type_ML === type || driver.hasOwnProperty('driverType') && driver.driverType === type;
    };

    const getDrivers = () => {
        let drivers = [];
        if (isPersonalAuto && lobModel.value.drivers) {
            drivers = lobModel.value.drivers;
        } else if (isPersonalUmbrella && lobModel.value.vehicleOperators) {
            drivers = lobModel.value.vehicleOperators;
        }
        return drivers.filter((driver) =>
            filterDriversForAutoandUmb(driver, 'rated')
            || (filterDriversForAutoandUmb(driver, 'excluded') && discloseExcludedDriver)
        );
    };

    /*
     * Get the list of available drivers/vehicle operators
     */
    const getOwners = () => {
        const owners = [];
        const drivers = getDrivers();
        if (isPersonalAuto) {
            drivers.forEach((d) => owners.push(d.person));
        } else if (isPersonalUmbrella) {
            drivers.forEach((v) => owners.push(v.contact));
        }
        return owners;
    };

    const getDisclosuresFromDriver = (driver) => {
        return driver.disclosures_ML || driver.disclosures || driver.disclosure;
    };

    const getMvrStatus = () => {
        const currentQuoteId = submissionVM?.bindData?.chosenQuote?.value;
        const storedStatus = sessionStorage.getItem('mvrStatus');
        const storedQuoteId = sessionStorage.getItem('chosenQuote');

        const isSameQuote = currentQuoteId && storedQuoteId && currentQuoteId === storedQuoteId;

        if (isSameQuote && (storedStatus === 'FOUND_VIOLATIONS' || storedStatus === 'NO_VIOLATIONS')) {
            return MLDisclosureUtil.mvrStatus[storedStatus];
        }

        let status = MLDisclosureUtil.mvrStatus.NOT_RUN_YET;

        if (!mvrExecuted) {
            return status;
        }

        const hasViolations = foundViolationsFromReport();
        const newStatusKey = hasViolations ? 'FOUND_VIOLATIONS' : 'NO_VIOLATIONS';

        status = MLDisclosureUtil.mvrStatus[newStatusKey];

        sessionStorage.setItem('mvrStatus', newStatusKey);
        if (currentQuoteId) {
            sessionStorage.setItem('chosenQuote', currentQuoteId);
        }

        return status;
    };

    const getPrimaryNamedInsuredState = () => {
        return _.get(submissionVM, 'baseData.primaryNamedInsured_ML.primaryAddress.state.value.code');
    };

    const initDisclosures = () => {
        const drivers = getDrivers();
        let assignedAccidents = [];
        let assignedClaims = [];
        let assignedViolations = [];
        drivers.forEach((driver) => {
            const disclosures = getDisclosuresFromDriver(driver);
            if (disclosures) {
                if (!_.isUndefined(disclosures.accidents)) {
                    assignedAccidents = assignedAccidents.concat(disclosures.accidents);
                }
                if (!_.isUndefined(disclosures.claims)) {
                    assignedClaims = assignedClaims.concat(disclosures.claims);
                }
                if (!_.isUndefined(disclosures.violations)) {
                    assignedViolations = assignedViolations.concat(disclosures.violations);
                }
            }
        })

        assignedAccidents.forEach((a) => { a.originalOwner = a.person.publicID; });
        assignedClaims.forEach((c) => { c.originalOwner = c.person.publicID; });
        assignedViolations.forEach((v) => { v.originalOwner = v.person.publicID; });

        setAccidents(assignedAccidents);
        setClaims(assignedClaims);
        setViolations(assignedViolations);

        if (!isPersonalAuto && lobModel.homeLosses_ML.value) {
            setLosses(losses.concat(lobModel.homeLosses_ML.value));
        }
    };

    const showHIDriverMVRReportPendingAlert = useCallback(() => {
        if (isPersonalAuto) {
            addErrorAlert(messages.orderMVRforHIDriverAgent, 'HIDriverMVRPendingAlert');
        }
    }, [addErrorAlert, isPersonalAuto]);


    const displayHIDriverWarning = () => {
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value');
        if (checkHiDrivers(drivers) && checkPendingMvrOrderStatus(drivers))
            return true;
        return false;
    }

    const setActivitiesFoundOnManualMvrOrder = () => {
        if (MLDisclosureUtil.isManualOrderMvr(quoteID)) {
            showPremiumChangedAlert();
            MLDisclosureUtil.setManualOrderMvr(quoteID, false);
        }
    };

    useEffect(() => {

        setPremiumChangedByMVRFlag();
        setActivitiesFoundOnManualMvrOrder();
        initDisclosures();

        if (currentStep.mlStepName === 'paDisclosureReviewToBuy' && displayHIDriverWarning()) {
            showHIDriverMVRReportPendingAlert();
        };
        // execure once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const assignDisclosuresToDrivers = () => {
        const _assignDisclosures = (driver, disclosuresOrig, disclosuresDest) => {
            const publicID = isPersonalUmbrella ? driver.contact.publicID : driver.person.publicID;

            disclosuresOrig.forEach((disclosure) => {
                if (disclosure && disclosure.person.publicID === publicID && (_.isUndefined(disclosure.removeReason) || disclosure.removeReason === null)) {
                    if (disclosure.originalOwner !== disclosure.person.publicID) {
                        disclosure.fixedID = null;
                    }
                    disclosuresDest.push(disclosure);
                }
            });
        };
        const _clearDriverDisclosures = (disclosures) => {
            disclosures.accidents = [];
            disclosures.claims = [];
            disclosures.violations = [];
        };

        const drivers = getDrivers();
        drivers.forEach((driver) => {
            const disclosures = getDisclosuresFromDriver(driver);
            _clearDriverDisclosures(disclosures);
            _assignDisclosures(driver, accidents, disclosures.accidents);
            _assignDisclosures(driver, claims, disclosures.claims);
            _assignDisclosures(driver, violations, disclosures.violations);
        });
    };

    const showHomeLossesOnly = () => {
        const drivers = getDrivers();
        return !isPersonalAuto && drivers.length <= 0;
    };

    const saveHomeLosses = () => {
        if (!isPersonalAuto && losses) {
            lobModel.homeLosses_ML.value = losses.filter((loss) => {
                return _.isUndefined(loss.removeReason) || loss.removeReason === null;
            });
        }
    };

    const approvedAllBlockingUWIssuesCallback = useCallback(() => {
        _.set(submissionVM, 'value.blockNavigation_ML', false);
    }, [submissionVM]);

    const nextStepText_Ext = () => {
        return (mvrExecuted ?
                <FormattedMessage
                    {...messages.confirmPremiumNextText}
                    values={{
                        confirmPremium: (
                            <strong>{translator(messages.confirmPremium)}</strong>
                        )
                    }}
                /> : <FormattedMessage
                    {...messages.continueText}
                    values={{
                        reviewYourQuote: (
                            <strong>{translator(messages.reviewYourQuote)}</strong>
                        )
                    }}
                />
        );
    };

    const updateProductModel = useCallback(() => {
        console.log('model was changed');
        updateWizardData(submissionVM);
    }, []);

    const onNext = async () => {
        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Quote Step Submitted', false, submissionVM, user, {
                        step: 'Disclosure Page',
                        action: 'Disclosure Submitted'
                    });
                } else {
                    PATrackEvent('Quote Step Submitted', false, submissionVM, user, {
                        step: 'Disclosure Page',
                        action: 'Disclosure Submitted'
                    });
                }
            });
        }

        if (currentStep.mlStepName === 'paDisclosureToQuote') {
            _.set(submissionVM, 'portalCurrentStep_ML.value', 'paDisclosureToQuote');
        } else if (currentStep.mlStepName === 'pupDisclosureToQuote') {
            _.set(submissionVM, 'portalCurrentStep_ML.value', 'pupDisclosureToQuote');
        }

        if (!isComponentValid) {
            return false;
        }

        assignDisclosuresToDrivers();
        saveHomeLosses();

        if (mvrExecuted) {
            if (pADriverSuspended() && !paSuspensionMessagedDisplayed) {
                callPADriverSuspended();
                return false;
            }
            return handleNextIfMVRExecuted();
        }

        const mvrViolations = MLDisclosureUtil.hasAssignedViolationsForQuote(quoteID)
        
        if (nextStepVisited() && !mvrViolations) {
            goNext();
        } else {
            _.unset(submissionVM.value, 'bindData.paymentDetails');
            showProgressDialog(platformMessages.saveAndQuoteSubmission);
            MLDisclosureUtil.setAssignedViolationsForQuote(quoteID, false)              

            try {
                const res = await LoadSaveService.saveAndQuoteSubmission(
                    submissionVM.value,
                    authHeader
                );

                clearWarningAlerts();
                submissionVM.value = res;

                let ignoreInsurviewWarning = true;
                if (isPersonalUmbrella) {
                    const warningMsgs = res.lobData.personalUmbrella.warnings
                    if (warningMsgs != null && warningMsgs.length > 0) {
                        warningMsgs.forEach((value) => {
                            if (value !== " " && value !== null) {
                                addWarningAlert(value, 'InsurviewWarning');
                            }
                        });
                        window.scrollTo(0, 0);
                        if (insurViewWarningMsg) {
                            ignoreInsurviewWarning = true;
                        } else {
                            ignoreInsurviewWarning = false;
                        }
                        setInsurViewWarningMsg(true);
                    }
                }

                if (ignoreInsurviewWarning === true) {
                    if (!nextStepVisited()) {
                        MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
                        return submissionVM;
                    }
                    goNext();
                }
            } catch (error) {
                if (error?.baseError && error?.baseError?.indexOf(CDC_EXCEPTION) > -1) {
                    hideProgressDialog();
                    MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                } else if(error?.baseError?.indexOf('5430') > -1) {
                    const regex = /DisplayableExceptionML:([\s\S]*?)(?=Messages_ML:)/;
                    const match = error?.baseError.match(regex);
                    let errorMessage = match ? match[1].trim() : '';
                    errorMessage = errorMessage.replace(/\s*Error code 5430\.?$/i, '').trim();

                    hideProgressDialog();
                    showErrorModal(null, errorMessage);
                }
                else if(error?.baseError?.indexOf("-31000-DISPLAYABLE_ERROR_ML") > -1) {
                    let errorMessage = between(error.baseError, "Messages_ML: [", "] ").replace(':,', ':').replace('.,', '.');
                    if (errorMessage.includes("Insufficient data available to generate a valid request. The request is missing required field(s).")) {
                        showErrorModal(messages.mvrOrderedError, errorMessage);
                    }
                    else {
                        showErrorModal(messages.uwIssuesThatBlockQuote, errorMessage);
                    }
                }  
                else {
                    throw error
                }
            } finally {
                hideProgressDialog();
            }
        }

        MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
        return false;
    };

    const openRiskAnalysisPopup = () => {
        const componentProps = {
            title: messages.riskAnalysis,
            CustomComponent: MLRatingFactorComponent,
            overrideProps: {
                jobOrPolicyNumber: submissionVM.quoteID.value,
                isQuote: true,
                state: submissionVM.baseData.policyAddress.state.value.code,
                authHeader,
                viewModelService,
                userTypeCode: submissionVM.userType_ML.value.code,
                isModernProduct
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }

    const resolvers = {
        resolveComponentMap: {
            mldisclosurecomponent: MLDisclosureComponent,
            mlscriptcomponent: MLScriptComponent,
            mluwissuespanelcomponent: MLUWIssuesPanelComponent
        },
        resolveCallbackMap: {
            onNext,
            updateProductModel,
            openRiskAnalysisPopup
        },
         resolveClassNameMap: styles,
    };

    const overrideProps = {
        uwIssuePanel: {
            visible: premiumChangedByMVRFlag === false,
            uwIssues,
            jobID: quoteID,
            wrapped: true,
            approvedAllBlockingUWIssuesCallback
        },
        riskAnalysisHeadingContainer: {
            visible: showFurtherRA()
        },
        forFurtherText: {
            content: translator(messages.furtherInfoMessage)
        },
        goToRiskAnalysisLink: {
            content: translator(messages.riskAnalysis)
        },
        discloseExcludedDriverInfo: {
            visible: discloseExcludedDriver
        },
        mlLossesComponent: {
            disclosures: losses,
            owners: homeLossOwners,
            type: MLDisclosureUtil.getLossType(),
            showAddButton: !mvrExecuted,
            hasEditPermission: userHasEditDisclosuresPermission,
            isAgent: true
        },
        accidentsRow: {
            visible: !showHomeLossesOnly()
        },
        mlAccidentsComponent: {
            disclosures: accidents,
            owners: getOwners(),
            type: MLDisclosureUtil.getAccidentType(),
            showAddButton: !mvrExecuted,
            hasEditPermission: userHasEditDisclosuresPermission,
            isAgent: true,
            drivers: getDrivers(),
            isPersonalAuto,
            shouldDiscloseExcluded: discloseExcludedDriver,
            updateProductModel,
            isModernProduct
        },
        claimsRow: {
            visible: !showHomeLossesOnly()
        },
        mlClaimsComponent: {
            disclosures: claims,
            owners: getOwners(),
            type: MLDisclosureUtil.getClaimType(),
            showAddButton: !mvrExecuted,
            hasEditPermission: userHasEditDisclosuresPermission,
            isAgent: true,
            drivers: getDrivers(),
            isPersonalAuto,
            shouldDiscloseExcluded: discloseExcludedDriver,
            updateProductModel,
            isModernProduct
        },
        violationsRow: {
            visible: !showHomeLossesOnly()
        },
        mlViolationsComponent: {
            disclosures: violations,
            owners: getOwners(),
            type: MLDisclosureUtil.getViolationType(),
            mvrStatus: getMvrStatus(),
            showAddButton: !mvrExecuted,
            hasEditPermission: userHasEditDisclosuresPermission,
            isAgent: true,
            drivers: getDrivers(),
            isPersonalAuto,
            shouldDiscloseExcluded: discloseExcludedDriver,
            primaryNamedInsuredState: getPrimaryNamedInsuredState(),
            updateProductModel,
            isModernProduct
        },
        nextDescription: {
            content: nextStepText_Ext()
        },
        stickyfootercomponent: {
            defaultContinueSectionId: 'footer',
            nextDescription: nextStepText_Ext(),
            onNext
        },
        nextButton: {
            disabled: displayHIDriverWarning()
        },
        mlScriptComponent: {
            visible: isGPA && !_.isEmpty(scriptML),
            mlScript: scriptML
        }
    };

    const skipOnResumeIf = () => {
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'paDisclosureToQuote') {
            console.log('Stopping on Disclosure Page becasue last visited step is paDisclosureToQuote');
            return false;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
            submissionVM.hvqQuoteID_ML.value &&
            submissionVM.isBundle_ML.value) {
            return true;
        }

        if (submissionVM.value.isBundle_ML
            && submissionVM.value.baseData.status_ML !== 'Draft') {
            return true;
        }

        console.log('Skipping Disclosure Page becuase everything is valid');
        return true;
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited()}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={nextStepText_Ext()}
            metadataPageId={!nextStepVisited() && _.get(isPersonalAuto ? paMetadata : pupMetadata, 'pageContent.id')}
            stickyComponentOverrideId='stickyfootercomponent'
        >
            <ViewModelForm
                uiProps={isPersonalAuto ? paMetadata.pageContent : pupMetadata.pageContent}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

GatewayDisclosurePage.propTypes = wizardProps;

export default GatewayDisclosurePage;